/* eslint-disable jsx-a11y/media-has-caption */
import { FC } from "react";
import generalSvg from "@/utils/svg-icon/general";
import styles from "@/styles/detail/DetailBookingSidebar/InfoModalPremium.module.scss";
import otherSvg from "@/utils/svg-icon/other";
import { useCurrency } from "@/utils/hooks/useCurrency";
import { useCurrencyConversion } from "@/utils/hooks/useCurrencyConversion";
import { formatPrice } from "@/utils/common/formatPrice";
import Btn from "../Btn";
import InfoModalContainer from "./InfoModal";

const InfoModalPremium: FC<{
    show: boolean;
    setShow: (state: boolean) => void;
    onBuy: (isPremiumFlag: boolean) => void;
    pricePremium: number;
    priceQuality: number;
}> = ({ show, setShow, onBuy, pricePremium, priceQuality }) => {
    const { Star } = generalSvg;
    const { CatPremiumResized } = otherSvg;
    const { currency } = useCurrency();
    const { convertPrice } = useCurrencyConversion();

    // Calcola la differenza di prezzo (in EUR)
    const differencePriceEUR = Math.abs(pricePremium - priceQuality);
    // Converte la differenza nella valuta selezionata
    const differencePriceConverted = parseFloat(
        convertPrice(differencePriceEUR)
    );
    // Formatta il prezzo nella valuta selezionata
    const formattedDifference = formatPrice(differencePriceConverted, currency);

    return (
        <InfoModalContainer title="" show={show} setShow={setShow}>
            <div className={styles.modalContainer}>
                <div className={styles.modalContainerLeft}>
                    <p className={styles.modalContainerLeftTitle}>Premium</p>
                    <div className={styles.modalContainerLeftImage}>
                        <CatPremiumResized />
                    </div>
                    <div className={styles.modalContainerLeftFeature}>
                        <Star />
                        <p className={styles.modalContainerLeftFeatureText}>
                            Exclusive accommodation
                        </p>
                    </div>
                    <div className={styles.modalContainerLeftFeature}>
                        <Star style={{ width: "62px" }} />
                        <p className={styles.modalContainerLeftFeatureText}>
                            Private transfers from the arrival in the
                            destination to your hotel and vv
                        </p>
                    </div>
                    <div className={styles.modalContainerLeftFeature}>
                        <Star />
                        <p className={styles.modalContainerLeftFeatureText}>
                            Private experiences
                        </p>
                    </div>
                    <div className={styles.modalContainerLeftFeature}>
                        <Star />
                        <p className={styles.modalContainerLeftFeatureText}>
                            Pre & post sale support
                        </p>
                    </div>
                    <div className={styles.modalContainerLeftFeature}>
                        <Star />
                        <p className={styles.modalContainerLeftFeatureText}>
                            Italian Experts
                        </p>
                    </div>
                </div>
                <div className={styles.modalContainerRight}>
                    <h1 className={styles.modalContainerRightTitle}>
                        These dates are also available in our Premium version!
                    </h1>
                    <p className={styles.modalContainerRightText}>
                        With an additional {formattedDifference} you can upgrade
                        your Experience with luxury hotels, private outings and
                        premium assistance.
                    </p>
                    <div>
                        <Btn
                            fullWith
                            onClick={() => {
                                onBuy(true);
                            }}
                        >
                            Choose Premium
                        </Btn>
                        <p
                            className={styles.modalContainerRightUnderelineText}
                            onClick={() => onBuy(false)}
                        >
                            Continue with Quality
                        </p>
                    </div>
                </div>
            </div>
        </InfoModalContainer>
    );
};

export default InfoModalPremium;
